import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

export const giftCardsRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/GiftCardDetailView.vue'),
        name: 'brand.gift-cards.detail',
        path: ':giftCardId',
        props: (route: RouteLocationNormalized) => ({
          giftCardId: route.params.giftCardId,
        }),
      },
    ],
    component: async () => import('../views/GiftCardsView.vue'),
    meta: {
      authZ: ({ user }) => user.can('update', 'gift-card'),
      title: 'restaurant.gift-cards',
    },
    name: 'brand.gift-cards',
    path: 'gift-cards',
  },
  {
    component: async () => import('../import/views/GiftCardImportView.vue'),
    meta: {
      authZ: ({ user }) => user.can('update', 'gift-card'),
      // The import wizard owns the full screen; keep the Owner Agent FAB out of
      // its lower-left controls.
      hideOwnerAgentWidget: true,
      title: 'restaurant.gift-cards',
    },
    name: 'brand.gift-cards.import',
    path: 'gift-cards/import',
  },
]
